// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8874) return "static/chunks/bbfbfb6c-a3e62ad28732be26.js";
	if (chunkId === 6221) return "static/chunks/6221-c4defe3f4c1a0a14.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9779 ? "d2d722bc" : chunkId) + "." + {"1097":"b52c6c2d95613291","9779":"77309aab734d0f26"}[chunkId] + ".js";
};